import React, { useEffect, useMemo, useState, useCallback } from "react";
import MdaeActionPopover from "../../../common_components/common_widgets/menu-action-popover";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import { getDataGridActionEllipsisComponent } from "../../../common_components/common_widgets/data-grid-action-ellipsis";
import dxDataGrid from "devextreme/ui/data_grid";
import { useDispatch, useSelector } from "react-redux";
import { GET_EMDR_INBOX_LIST } from "./services/get-emdr-inbox-list";
import {
  SET_EMDR_INBOX_TYPE,
  TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER,
} from "./reducers/emdr-ibox-reducer";
import EmdrInboxDetail from "./emdr-inbox-detail";
import { MasterDetail } from "devextreme-react/data-grid";
import {
  HIDE_LOADER,
  SHOW_LOADER,
} from "../../../common_components/mdae-common-reducer";
import { MARK_DOCUMENT_AS_ARCHIEVE } from "./services/mark-document-as-archieve";
import { actions, callOperation } from "async-ops";
import mdaeNotify, {
  NOTIFY_MESSAGE_TYPE,
} from "../../../common_components/common_widgets/toast/notify";
import { first } from "lodash";
import { EMDR_INBOX_PAGE_TABS } from "../constant";
import { bindActionCreators } from "redux";
import DataGridRecordsFilter from "../../../common_components/common_widgets/data-grid-records-filter/component";
import { GET_EMDR_UNSEEN_DOC_COUNT } from "./services/get-emdr-unseen-doc-count";
import { MARK_EMDR_DOCUMENT_AS_SEEN } from "./services/mark-document-as-seen";
import $ from "jquery";
import "./index.scss";
import AttachedDocumentToAuditOrCase, {
  toggleAttachedDocumentToAuditOrCasePopup,
} from "./attached-document-to-audit-or-case-pop-up";
import { EMDR_ATTACH_POPUP_MODE } from "../constant";
import {
  downloadDocumentFromS3,
  previewDocumentFromS3,
} from "../../../common_components/document-management/component";
import { SET_HEADER_RANGE_FILTER_COUNT } from "../../external-audit/audit-list/reducers/audit-list-reducer";
import { SET_EMDR_UNSEEN_DOC_COUNT } from "../../../common_components/common_widgets/navigation_bar/reducers/mdae-navigation-bar-reducer";

interface IEMDRInbox {
  type: string;
}
  // Function to update the count state (e.g., after archiving or restoring a document)
  export const updateCount = (dispatch) => {
    try {
      callOperation(GET_EMDR_UNSEEN_DOC_COUNT, {
        menuId: 610,
      }).then(function(response) {
        dispatch({
          type: SET_EMDR_UNSEEN_DOC_COUNT,
          noOfDocSeen: response.noOfDocSeen,
        })
        localStorage.setItem('updatedUnseenDocCount', response.noOfDocSeen);
      });

    } catch (error) {
      console.error("Error fetching count:", error);
    }
  };
const EMDRInboxItem: React.FC<IEMDRInbox> = (props) => {
  const [eMDRInboxDataGridInstance, seteMDRInboxDataGridInstance] = useState<
    dxDataGrid
  >(null);

  const dispatch = useDispatch();

  const getCurrentSelectedRowData: any = () => {
    return first(eMDRInboxDataGridInstance?.getSelectedRowsData());
  };
  const eMDRInboxList = useSelector(
    (state) => state["emdrInboxReducer"].eMDRInboxList
  );
  const monthRange = useSelector(
    (state) => state["documentManagementReducer"].headerRangeFilterCount
  );
  const currentItemNotificationCount = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.notificationCounts?.find(x => x.name === 'Inbox')?.count
  );
  const handleStorageChange = useCallback((event:StorageEvent) => {
    if (event.key === "updatedUnseenDocCount" && currentItemNotificationCount !== event.newValue) {
      updateCount(dispatch);
      dispatch(
        actions.asyncOperationStart(GET_EMDR_INBOX_LIST, {
          type: props.type,
          monthRange: monthRange,
        })
      );
    }
  },[]);
  useEffect(() => {
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    if (props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB) {
      dispatch(
        actions.asyncOperationStart(GET_EMDR_INBOX_LIST, { type: props.type })
      );
      console.log("Fetching inbox data");
    } else if (props.type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB) {
      dispatch(
        actions.asyncOperationStart(GET_EMDR_INBOX_LIST, {
          type: props.type,
          monthRange: monthRange,
        })
      );
      console.log("Fetching history data");
    }
    dispatch({
      type: SET_EMDR_INBOX_TYPE,
      data: {
        type: props.type,
      },
    });
  }, [dispatch, props.type]);

  const toggleemdrInboxListActionPopover = useCallback(
    (isVisible, target) => {
      const currentSelectedRowData = getCurrentSelectedRowData();
      if (currentSelectedRowData.maliciousFileInd == null) {
        mdaeNotify({
          message:
            "Virus scan in progress.",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      } else
      if (currentSelectedRowData.maliciousFileInd) {
        mdaeNotify({
          message:
            "This document has been flagged by the MDaudit system and is unable to be downloaded. Please reach out to support.",
          messageType: NOTIFY_MESSAGE_TYPE.ERROR,
        });
      } else
        dispatch({
          type: TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER,
          data: {
            emdrInboxListDataGridActionPopoverTarget: target,
            isemdrInboxListDataGridActionPopoverVisible: isVisible,
          },
        });
    },
    [dispatch, getCurrentSelectedRowData]
  );
  const onRowPrepared = (e) => {
    if (e.rowType === "data" && !e.data.isDocumentSeen) {
      $(e.rowElement).addClass("unseen-document");
    }
  };

  const emdrInboxDataGridOptions = useMemo(() => {
    return getemdrInboxDataGridOptions(
      toggleemdrInboxListActionPopover,
      eMDRInboxList,
      dispatch,
      seteMDRInboxDataGridInstance,
      props.type,
      onRowPrepared
    );
  }, [eMDRInboxList, props.type]);

  const markDocumentAsArchieveUnArchieve = useCallback(
    (currentSelectedRowData, dispatch) => {
      dispatch({ type: SHOW_LOADER });
      try {
        callOperation(MARK_DOCUMENT_AS_ARCHIEVE, {
          documentId: currentSelectedRowData.documentId,
          letterId: currentSelectedRowData.letterId,
          type: props.type,
        }).then(function(response) {
          dispatch({ type: HIDE_LOADER });
          if (response.markDocumentAsArchieveUnArchieve) {
            callOperation(MARK_EMDR_DOCUMENT_AS_SEEN, {
              documentId: currentSelectedRowData.documentId,
              letterId: currentSelectedRowData.letterId,
            }).then(function(response) {
              dispatch(actions.asyncOperationStart(GET_EMDR_INBOX_LIST, {
                type: props.type,
                monthRange: monthRange,
              }));
              mdaeNotify({
                message:
                  props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB
                    ? "Letter has been archived successfully."
                    :" Letter has been restored successfully.",
                messageType: NOTIFY_MESSAGE_TYPE.SUCCESS,
              });
              updateCount(dispatch);
            });
          } else {
            mdaeNotify({
              message:
                props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB
                  ? "Unable To archive letter."
                  : "Unable To restore letter.",
              messageType: NOTIFY_MESSAGE_TYPE.ERROR,
            });
          }
        });
      } catch (error) {
        console.log(error);
      }
    },
    [actions.asyncOperationStart]
  );
  const asyncAction = bindActionCreators(
    {
      asyncOperationStart: actions.asyncOperationStart,
    },
    dispatch
  );
  const createAnAudit = useCallback(
    (currentSelectedRowData, dispatch) => {
      try {
        if(currentSelectedRowData.claimCount ===1){
          window.open("").location.href =
          window.location.origin +
          "/externalaudit/casesearch?documentid=" +
          currentSelectedRowData.documentId;
        }
        else{
          window.open("").location.href =
          window.location.origin +
          "/externalaudit/manualaudit?documentid=" +
          currentSelectedRowData.documentId;
        }
      } catch (error) {
        console.log(error);
      }
    },
    [dispatch]
  );

  const attachToAuditOrCase = useCallback(
    (currentSelectedRowData, dispatch) => {
      try {
        toggleAttachedDocumentToAuditOrCasePopup(
          dispatch,
          true,
          currentSelectedRowData.documentId,
          EMDR_ATTACH_POPUP_MODE.ATTACH_DOCUMENT
        );
      } catch (error) {
        console.log(error);
      }
    },
    [dispatch]
  );

  const addCasesToExistingAudit = useCallback(
    (currentSelectedRowData, dispatch) => {
      try {
        toggleAttachedDocumentToAuditOrCasePopup(
          dispatch,
          true,
          currentSelectedRowData.documentId,
          EMDR_ATTACH_POPUP_MODE.ADD_CASES
        );
      } catch (error) {
        console.log(error);
      }
    },
    [dispatch]
  );

  const emdrInboxListActionPopoverMenuList = () => [
    {
      text: "Preview",
      icon: () => (
        <div style={{ height: "14px" }} className="preview-action-icon"></div>
      ),
      onClick: (e) => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        const attachedLevelId = currentSelectedRowData.attachedLevelId
          ? currentSelectedRowData.attachedLevelId.split(",")[0]
          : "0";
        previewDocumentFromS3(
          dispatch,
          asyncAction,
          currentSelectedRowData.s3ObjectName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.originalFileName,
          currentSelectedRowData.documentId,
          attachedLevelId,
          currentSelectedRowData.attachedLevelName
        )
        toggleemdrInboxListActionPopover(false, null);
      },
    },
    {
      text: "Download",
      icon: () => (
        <div style={{ height: "16px" }} className="download-icon"></div>
      ),
      visible: true,
      onClick: (e) => {
        const currentSelectedRowData = getCurrentSelectedRowData();
        const attachedLevelId = currentSelectedRowData.attachedLevelId
          ? currentSelectedRowData.attachedLevelId.split(",")[0]
          : "0";
        downloadDocumentFromS3(
          dispatch,
          asyncAction,
          currentSelectedRowData.s3ObjectName,
          currentSelectedRowData.documentName,
          currentSelectedRowData.originalFileName,
          currentSelectedRowData.documentId,
          attachedLevelId,
          currentSelectedRowData.attachedLevelName
        );
        toggleemdrInboxListActionPopover(false, null);
      },
    },
    {
      text: "Create Audit",
      icon: () => (
        <div
          style={{ height: "16px" }}
          className="create-new-action-icon"
        ></div>
      ),
      visible: props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB,
      onClick: () => {
        createAnAudit(getCurrentSelectedRowData(), dispatch);
        toggleemdrInboxListActionPopover(false, null);
      },
    },
    {
      text: "Add Case(s) to Audit",
      icon: () => (
        <div
          style={{ height: "16px" }}
          className="edit-action-icon"
        ></div>
      ),
      visible: props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB,
      onClick: () => {
        toggleemdrInboxListActionPopover(false, null);
        addCasesToExistingAudit(getCurrentSelectedRowData(), dispatch);
      },
    },
    {
      text: "Attach to Audit/Case",
      icon: () => (
        <div
          style={{ height: "16px" }}
          className="no-tasks-assigned-icon"
        ></div>
      ),
      visible: props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB,
      onClick: () => {
        toggleemdrInboxListActionPopover(false, null);
        attachToAuditOrCase(getCurrentSelectedRowData(), dispatch);
      },
    },
    {
      text:
        props.type === EMDR_INBOX_PAGE_TABS.INBOX_TAB
          ? "Archive Document"
          : "Restore Document",
      icon: () => (
        <div style={{ height: "16px" }} className="box-archive-solid"></div>
      ),
      visible: true,
      onClick: () => {
        toggleemdrInboxListActionPopover(false, null);
        markDocumentAsArchieveUnArchieve(getCurrentSelectedRowData(), dispatch);
      },
    },
  ];
  return (
    <div className="emdr-inbox-container">
      <MdaeActionPopover
        mdaePopoverConfig={{
          id: "pnlemdrInboxListActionPopover",
          mdaeDataUpdaterConfig: [
            {
              actionType: TOGGLE_EMDR_INBOX_LIST_ACTION_POPOVER,
              reducerName: "emdrInboxReducer",
              widgetOptionBindings: {
                target: "emdrInboxListDataGridActionPopoverTarget",
                visible: "isemdrInboxListDataGridActionPopoverVisible",
              },
            },
          ],
        }}
        menuItemListFunction={emdrInboxListActionPopoverMenuList}
      />
      {props.type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB && (
        <DataGridRecordsFilter
          id="pnlDocumentsDataGridFilter"
          infoText="Document list will display documents for the most recent month based on the number entered in the filter."
          titleText="Refresh Document List"
          prefixText="Show The"
          suffixText="month(s) most recent document(s)"
          rangeNumber={6}
          fetchOptions={{
            reducerName: "documentManagementReducer",
            valueActionType: SET_HEADER_RANGE_FILTER_COUNT,
            fetchActionType: GET_EMDR_INBOX_LIST,
            data: {
              monthRange: monthRange,
              type: props.type,
            },
          }}
        />
      )}
      <MdaeDataGrid {...emdrInboxDataGridOptions}>
        <MasterDetail enabled={true} component={EmdrInboxDetail} />
      </MdaeDataGrid>
      <AttachedDocumentToAuditOrCase />
    </div>
  );
};
const getemdrInboxDataGridOptions = (
  toggleActionPopover,
  eMDRInboxList,
  dispatch,
  seteMDRInboxDataGridInstance,
  type,
  onRowPrepared
) => {
  const requestorDataGridOption: IMdaeDataGridProps = {
    id: "pnleMDRInboxList",
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    clearFilterButtonId: "btn-eMDR-inbox-list-grid-clear-filter",
    export: {
      enabled: true,
      fileName:
        type === EMDR_INBOX_PAGE_TABS.INBOX_TAB ? "eMDRInbox" : "eMDRHistory",
    },
    headerFilter: { visible: true },
    selection: { mode: "single" },
    dataSource: eMDRInboxList,
    allowColumnResizing: true,
    allowColumnReordering: true,
    filterRow: {
      visible: true,
    },
    onInitialized(e) {
      seteMDRInboxDataGridInstance(e.component);
    },
    onCellPrepared(e) {
      if (e.rowType == "data" && e.data.maliciousFileInd == null) {
        $(e.cellElement).css("font-style", "italic");
        setTimeout(() => {
          $(e.cellElement)
            .find(".mdae-datagrid-action-ellipsis-icon")
            .removeClass("fas fa-ellipsis-h");
          $(e.cellElement)
            .find(".mdae-datagrid-action-ellipsis-icon")
            .addClass("fas fa-hourglass-half");
          $(e.cellElement).attr("title", "Virus scan in progress");
        });
      } else if (e.rowType == "data" && e.data.maliciousFileInd) {
        $(e.cellElement).addClass("malicious-document");
        setTimeout(function() {
          $(e.cellElement)
            .find(".mdae-datagrid-action-ellipsis-icon")
            .addClass("malicious-document");
          $(e.cellElement).attr(
            "title",
            "This file was found to be infected with malware and cannot be viewed or downloaded."
          );
        });
      }
    },
    mdaeColumns: [
      {
        fixed: true,
        alignment: "center",
        width: 50,
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: "emdr-inbox",
            entityId: e.data.documentId,
            currentRowData: e.data,
            type: "usingDispatch",
            dispatch,
          });
        },
      },
      {
        caption: "DocumentId",
        dataField: "documentId",
        width: 150,
        visible: false,
        showInColumnChooser: false,
      },
      {
        caption: "Document Type",
        dataField: "letterType",
        width: 130,
      },
      {
        caption: "Letter ID",
        dataField: "letterId",
        width: 200,
      },
      {
        caption: "Letter Date",
        dataField: "letterDate",
        dataType: "date",
        format: "shortDate",
        width: 110,
      },
      {
        caption: "Respond By",
        dataField: "letterRespondBy",
        width: 110,
        dataType: "date",
        format: "shortDate",
      },
      {
        caption: "Received Date",
        dataField: "createDate",
        dataType: "datetime",
        width: 150,
      },
      {
        caption: "File Name",
        dataField: "originalFileName",
        width: 180,
        visible: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        showInColumnChooser: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
      },
      {
        caption: "Target Name",
        dataField: "targetName",
        width: 150,
      },
      {
        caption: "Target NPI",
        dataField: "targetNPI",
        width: 100,
      },
      {
        caption: "Source/Jurisdiction",
        dataField: "reviewContractorCode",
        width: 120,
      },
      {
        caption: "Review Contractor",
        dataField: "reviewContractor",
        width: 180,
      },
      {
        caption: "Audit ID",
        dataField: "attachedLevelId",
        width: 80,
        visible: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        showInColumnChooser: type === EMDR_INBOX_PAGE_TABS.HISTORY_TAB,
        cellRender: (cellData) => {
          const attachedLevelIds =
            cellData.data?.attachedLevelId?.split(",") || [];
          if (attachedLevelIds.length > 0) {
            return attachedLevelIds.map((id, index) => {
              const auditURLString = "/externalaudit/audit?auditId=";
              return (
                <span key={index} style={{ whiteSpace: "nowrap" }}>
                  <a href={auditURLString + id.trim()} target="_blank">
                    {id.trim()}
                  </a>
                  {index < attachedLevelIds.length - 1 && ", "}
                </span>
              );
            });
          } else {
            return "N/A";
          }
        },
      },
      {
        caption: "Facility Name",
        dataField: "facilityName",
        width: 180,
      },
      {
        caption: "Claim Count",
        dataField: "claimCount",
        width: 120,
        alignment: "left",
      },
    ],
    onRowPrepared: onRowPrepared,
  };
  return requestorDataGridOption;
};
export default EMDRInboxItem;
